var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlipArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 67,
    viewBox: "0 0 70 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H64L64 6V66M64 6L4 62.8657",
    stroke: "currentColor",
    strokeWidth: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipArrow);
export default __webpack_public_path__ + "static/media/flip-arrow.3519726587a74a2f58e32084f1aaf18f.svg";
export { ForwardRef as ReactComponent };